import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Securities } from './securities';

export abstract class BaseKigGuard {
  public abstract roles: any[];
  protected constructor(
    protected router: Router,
    protected securities: Securities
  ) {
  }

  // noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.securities.setRoles().then(x =>{
      if (!this.securities.hasPrivilegesForRoles(this.roles)) {
        this.router.navigate([`${Securities.unauthRoute}`]);
        return false;
      } else {
        return true;
      }
    });

  }
}

@Injectable()
export class KigAuthGuard extends BaseKigGuard {
  public roles: any[] = [ Securities.userReadWrite, Securities.adminUser ];
  public constructor(
    protected router: Router,
    protected securities: Securities
  ) {
    super(router,  securities);
  }
}
